import { render, staticRenderFns } from "./ReactionToaster.vue?vue&type=template&id=0fc545fa&scoped=true"
import script from "./ReactionToaster.vue?vue&type=script&lang=js"
export * from "./ReactionToaster.vue?vue&type=script&lang=js"
import style0 from "./ReactionToaster.vue?vue&type=style&index=0&id=0fc545fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc545fa",
  null
  
)

export default component.exports